module.exports = __webpack_public_path__ + "img/Photo-D-Savvas.87a19e39.jpg";